import { Container, Row, Col, Button } from "react-bootstrap";
import { motion } from "framer-motion";

const SecuritySection = () => {
  return (
    <section className="security-section py-5">
      <Container className="text-center">
        <motion.h4
          className="fw-bold mb-4 text-secondary"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          Your security comes first. Always.
        </motion.h4>

        <motion.p
          className="security-description mx-auto mb-5"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          We use Plaid to connect your accounts with bank-level encryption.
          All connections are read-only, and your credentials are never stored or shared.
          Stop overpaying and start keeping more of what you earn.
        </motion.p>
      </Container>

      {/* Call to Action Box */}
      <Container className="security-started">
        <Row className="align-items-center security-box mx-auto rounded-4 p-4">
          <Col
            lg={9}
            className="text-center text-lg-start mb-4 mb-lg-0 d-flex flex-column justify-content-center"
          >
            <h3 className="fw-bold text-dark mb-2">
              Keep more of what you earn.
            </h3>
            <p className="text-secondary mb-3 fs-5">
              Join thousands of freelancers and small business owners who trust
              WriteOffGenie to simplify tax season.
            </p>
            <p className="text-muted small">
              No credit card required • Secure • IRS-Ready
            </p>
          </Col>

          <Col
            lg={3}
            className="d-flex justify-content-center align-items-center"
          >
            <Button className="get-started-btn px-4 py-3 rounded-3">
              <a href="/download" 
              style={{textDecoration:"none",color:"white"}}
              >

              Get Started For Free
              </a>
            </Button>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SecuritySection;
